/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import partyEvent from './Videos/Party Evennt Website.mp4'
import moviesHub from './Videos/Movie Hub.mp4'
import smartLogin from './Videos/Smart Login.mp4'
import lampApp from './Videos/Lamp Application.mp4'
import bookMarker from './Videos/Book Marker.mp4'
import randomQuotes from './Videos/Random Quotes.mp4'

export default function Myprojects() {
  return (
    <>
    <div className="row w-100 m-auto my-5 py-5 g-3">
      {/*----------------------------------Party Event Website Card----------------------------------------*/}
  <div className="col-md-6">
    <div className="card mb-3 p-1 pt-2 h-100">
    <h5 className="card-title text-dark fw-bolder text-center">Party Event Website</h5>
  <div className="row g-0">
    <div className="col-md-7 d-flex align-items-center px-1 py-2">
    <video controls className='w-100'>
      <source src={partyEvent} type="video/mp4"
      />
      Sorry, your browser doesn't support videos.
    </video>
    </div>
    <div className="col-md-5 text-dark">
      <div className="card-body">
        
        <p className="card-text">A count down App for a party using “HTML,CSS & Js”</p>
        {/*---------------------------------Buttons of visiting the website----------------------------------*/}

<div className="row g-2">
  <a href="https://muhammeednabil.github.io/Party-Event/" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Web site link</button></a>
  <a href="https://github.com/MuhammeedNabil/Party-Event" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Code link</button></a>
</div>
<p className="card-text text-center mt-1"><small className="text-muted">Last updated 24 days ago</small></p>

      </div>
    </div>
  </div>
</div>
</div>

      {/*----------------------------------Movies Hub Website Card----------------------------------------*/}
      <div className="col-md-6">
    <div className="card mb-3 p-1 pt-2 h-100">
    <h5 className="card-title text-dark fw-bolder text-center">Noxe Movies Hub Website</h5>
  <div className="row g-0">
    <div className="col-md-7 d-flex align-items-center px-1 py-2">
    <video controls className='w-100'>
      <source src={moviesHub} type="video/mp4"
      />
      Sorry, your browser doesn't support videos.
    </video>
    </div>
    <div className="col-md-5 text-dark">
      <div className="card-body">
        <p className="card-text">Noxe Movies Hub for trending movies using “React, JS, HTML,CSS, and API's”</p>
        {/*---------------------------------Buttons of visiting the website----------------------------------*/}
<div className="row g-2">
  <a href="https://noxehub.web.app/" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Web site link</button></a>
  <a href="https://github.com/MuhammeedNabil/Noxe-website" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Code link</button></a>
</div>
<p className="card-text text-center mt-1"><small className="text-muted">Last updated on Jun 25</small></p>

      </div>
    </div>
  </div>
</div>
</div>

      {/*-------------------------------turn lamp on & off Website Card-----------------------------------*/}
      <div className="col-md-6">
    <div className="card mb-3 p-1 pt-2 h-100">
    <h5 className="card-title text-dark fw-bolder text-center">Turn Lamp on & off Applicaton</h5>
  <div className="row g-0">
    <div className="col-md-7 d-flex align-items-center px-1 py-2">
    <video controls className='w-100'>
      <source src={lampApp} type="video/mp4"
      />
      Sorry, your browser doesn't support videos.
    </video>
    </div>
    <div className="col-md-5 text-dark">
      <div className="card-body">
        <p className="card-text">A small Application making the lamp turned On or Off using “HTML,CSS & Js”</p>
        {/*---------------------------------Buttons of visiting the website----------------------------------*/}
<div className="row g-2">
  <a href="https://muhammeednabil.github.io/Turn-Light-On-Off/" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Web site link</button></a>
  <a href="https://github.com/MuhammeedNabil/Turn-Light-On-Off" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Code link</button></a>
</div>
<p className="card-text text-center mt-1"><small className="text-muted">Last updated on Jun 11</small></p>

      </div>
    </div>
  </div>
</div>
</div>

      {/*----------------------------------Book Marker Website Card----------------------------------------*/}
      <div className="col-md-6">
    <div className="card mb-3 p-1 pt-2 h-100">
    <h5 className="card-title text-dark fw-bolder text-center">Book Marker Application</h5>
  <div className="row g-0">
    <div className="col-md-7 d-flex align-items-center px-1 py-2">
    <video controls className='w-100'>
      <source src={bookMarker} type="video/mp4"
      />
      Sorry, your browser doesn't support videos.
    </video>
    </div>
    <div className="col-md-5 text-dark">
      <div className="card-body">
        <p className="card-text">Small Book Marker App. Where you can save your important website links to make it easier to reach using “HTML, CSS, Js”</p>
        {/*---------------------------------Buttons of visiting the website----------------------------------*/}
<div className="row g-2">
  <a href="https://muhammeednabil.github.io/Book-Marker/" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Web site link</button></a>
  <a href="https://github.com/MuhammeedNabil/Book-Marker" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Code link</button></a>
</div>
<p className="card-text text-center mt-1"><small className="text-muted">Last updated on May 31</small></p>

      </div>
    </div>
  </div>
</div>
</div>

      {/*----------------------------------Random qoutes Website Card----------------------------------------*/}
      <div className="col-md-6">
    <div className="card mb-3 p-1 pt-2 h-100">
    <h5 className="card-title text-dark fw-bolder text-center">Random Quotes Application</h5>
  <div className="row g-0">
    <div className="col-md-7 d-flex align-items-center px-1 py-2">
    <video controls className='w-100'>
      <source src={randomQuotes} type="video/mp4"
      />
      Sorry, your browser doesn't support videos.
    </video>
    </div>
    <div className="col-md-5 text-dark">
      <div className="card-body">
        <p className="card-text">Small App. get a random quotes for each click on the button using “HTML,CSS, API's & Js”</p>
        {/*---------------------------------Buttons of visiting the website----------------------------------*/}
<div className="row g-2">
  <a href="https://muhammeednabil.github.io/Random-Quotes/" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Web site link</button></a>
  <a href="https://github.com/MuhammeedNabil/Random-Quotes" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Code link</button></a>
</div>
<p className="card-text text-center mt-1"><small className="text-muted">Last updated on May 31</small></p>

      </div>
    </div>
  </div>
</div>
</div>

      {/*----------------------------------Smart-Login Website Card----------------------------------------*/}
      <div className="col-md-6">
    <div className="card mb-3 p-1 pt-2 h-100">
    <h5 className="card-title text-dark fw-bolder text-center">Smart Login Application</h5>
  <div className="row g-0">
    <div className="col-md-7 d-flex align-items-center px-1 py-2">
    <video controls className='w-100'>
      <source src={smartLogin} type="video/mp4"
      />
      Sorry, your browser doesn't support videos.
    </video>
    </div>
    <div className="col-md-5 text-dark">
      <div className="card-body">
        <p className="card-text">Small App. for Smart Login that prevent the unlogin users to get home page using “HTML,CSS, API's & Js”</p>
        {/*---------------------------------Buttons of visiting the website----------------------------------*/}
<div className="row g-2">
  <a href="https://muhammeednabil.github.io/Login-Application/" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Web site link</button></a>
  <a href="https://github.com/MuhammeedNabil/Login-Application" target={'_blank'}><button className='btn btn-info rounded-pill w-100'>Code link</button></a>
</div>
<p className="card-text text-center mt-1"><small className="text-muted">Last updated on May 31</small></p>

      </div>
    </div>
  </div>
</div>
</div>

</div>
    </>
  )
}
